"use client";
import styled from "@emotion/styled";
import dayjs from "dayjs";
import Image from "next/image";
import Link from "next/link";
import { useParams } from "next/navigation";
import React, { useEffect, useState } from "react";
import { getBlogs } from "../../../actions/blog";
import {
  CardContent,
  CardDesc,
  CardImg,
  CommonCard,
  SecondaryOuter,
} from "../../../components/molecules";
import { getImageUrlNew, getLink } from "../../../lib/util";
import { useDictionary } from "../../../context/dictionaryProvider";

const BlogList = ({
  initialData = [],
  initialPagination = {},
  searchParams = {},
}) => {
  const params = useParams();
  const dict = useDictionary();
  const [blogs, setBlogs] = useState(initialData);
  const [pagination, setPagination] = useState({
    ...initialPagination,
    start: initialPagination?.start + initialPagination?.limit,
  });

  useEffect(() => setBlogs(initialData), [initialData]);
  useEffect(
    () =>
      setPagination({
        ...initialPagination,
        start: initialPagination?.start + initialPagination?.limit,
      }),
    [initialPagination]
  );

  const handleClick = async () => {
    const res = await getBlogs(
      {
        ...searchParams,
        limit: pagination?.limit,
        start: pagination?.start,
      },
      params
    );
    if (res) {
      setBlogs([...blogs, ...(res?.data || [])]);
      setPagination((prev) => ({
        ...prev,
        start: prev.start + prev.limit,
        total: res?.meta?.pagination.total,
      }));
    }
  };

  return (
    <BlogListContainer className="md:px-10">
      <h3></h3>
      <ul className="grid grid-col-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 mb-24">
        {blogs.map((blog, index) => (
          <li key={index}>
            <CommonCard>
              {blog?.thumbnail_image?.url && (
                <CardImg>
                  <div className="overlayContainer w-full h-[302px] md:h-[380px] rounded-2xl overflow-hidden">
                    <Image
                      loading="lazy"
                      src={getImageUrlNew(blog?.thumbnail_image, "small")}
                      alt="Blog Image"
                      fill
                      objectFit="cover"
                      className="h-full w-full"
                      width=""
                      height=""
                    />
                  </div>
                </CardImg>
              )}

              <CardContent>
                <p className="text-xs font-normal text-[#1a1414] mb-2">
                  {blog?.created_date
                    ? dayjs(blog?.created_date).format("DD MMMM YYYY")
                    : dayjs(blog?.publishedAt).format("DD MMMM YYYY")}
                </p>
                <Link
                  prefetch={false}
                  href={getLink(`/${params?.lang}/blog/${blog?.slug}`)}
                >
                  <h2 className="font-bold text-[#1a1414] text-lg mb-2">
                    {blog?.title}
                  </h2>
                </Link>
                <CardDesc>{blog?.short_description}</CardDesc>
              </CardContent>
            </CommonCard>
          </li>
        ))}
      </ul>
      {pagination?.total > blogs?.length && (
        <SecondaryOuter className="mx-auto mb-12" onClick={handleClick}>
          {dict?.learnMore}
        </SecondaryOuter>
      )}
    </BlogListContainer>
  );
};

export default BlogList;

const BlogListContainer = styled.div``;
